import { FunctionComponent, useState } from 'react'
import { DeviceInfo } from '@capacitor/device'
import styles from './downloadMobileApp.module.scss'
import { Fade, Snackbar } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

interface DownloadMobileAppProps {
    device: DeviceInfo
    isAuth: boolean
}

const DownloadMobileApp: FunctionComponent<DownloadMobileAppProps> = ({ device, isAuth }: DownloadMobileAppProps) => {
    const { t } = useTranslation()

    const [state, setState] = useState({
        open: true,
        Transition: Fade
    })

    function handleClose(): void {
        setState({
            ...state,
            open: false
        })
    }

    return (
        <Snackbar
            open={state.open}
            onClose={handleClose}
            anchorOrigin={
                isAuth ? { vertical: 'top', horizontal: 'center' } : { vertical: 'bottom', horizontal: 'center' }
            }
            className={`${isAuth ? styles.snackBarMobileConnected : ''} ${styles.snackBarMobile}`}
            slots={{ transition: state.Transition }}
        >
            <div className={styles.snackBarContent}>
                <div className={styles.snackBarInfo}>
                    <Close className={styles.closeIcon} onClick={handleClose} />
                    <img src='/images/cald.svg' className={styles.snackBarImg} alt='CALD' />
                    <div className={styles.snackBarText}>
                        <p className={styles.snackBarTextApplicationName}>{t('CALD')}</p>
                        <p className={styles.snackBarTextDescription}>{t('yoursSlotsOneClick')}</p>
                    </div>
                </div>
                <a
                    href={
                        device.operatingSystem === 'ios'
                            ? 'https://apps.apple.com/fr/app/cr%C3%A8che-a-la-demande/id1600278008'
                            : 'https://play.google.com/store/apps/details?id=fr.crechealademande.app'
                    }
                >
                    {t('get')}
                </a>
            </div>
        </Snackbar>
    )
}

export default DownloadMobileApp
